// Block sizing constants and the pure size formula — the frontend mirror of
// internal/domain.CalcBlockSize (port of contribution-blocks.html:954). The
// Sizer tool uses it to preview a size with no write; the server recomputes it
// authoritatively on PATCH /api/blocks/{id}/score.

export interface Tier {
  min: number;
  max: number;
  desc: string;
}

// TIERS maps an impact tier (1..5) to its [min,max] block range (requirements §5.1).
export const TIERS: Record<number, Tier> = {
  5: { min: 300, max: 500, desc: "Highest Revenue / Profit Driving" },
  4: { min: 200, max: 300, desc: "Significant Revenue / Profit Driving" },
  3: { min: 100, max: 200, desc: "Revenue-Enabling Work" },
  2: { min: 50, max: 100, desc: "Incremental Contribution" },
  1: { min: 0, max: 50, desc: "Operational Necessity" }
};

// SIG_DESCS maps a significance step (1..5) to its meaning (requirements §5.2).
export const SIG_DESCS: Record<number, string> = {
  5: "Defines Trajectory",
  4: "Builds Company Strategy",
  3: "Cross-Functional Leverage",
  2: "Functional Enablement",
  1: "Functional Contribution"
};

// calcBlockSize linearly positions a size within the impact tier's bracket
// (§5.3): round(min + ((sig-1)/4) * (max-min)). Impact selects the bracket;
// significance positions within it. Inputs are assumed 1..5 (the Sizer
// constrains its controls). Returns 0 for an unknown impact tier.
export function calcBlockSize(impact: number, significance: number): number {
  const tier = TIERS[impact];
  if (tier === undefined) {
    return 0;
  }
  return Math.round(tier.min + ((significance - 1) / 4) * (tier.max - tier.min));
}
